import React, { Component } from "react";
import { connect } from 'react-redux';
import { setTicaretTipi } from "../../actions/Actions";

class TicaretTipiDropDown extends Component {
    render() {
        return (
            <div>
                <select defaultValue="0" className="form-control" onChange={(e) => this.props.setTicaretTipi(e.target.value)} >
                    <option value="0" disabled>Select...</option>
                    <option value="1">İthalat</option>
                    <option value="2">İhracat</option>
                </select>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    setTicaretTipi: (ticaretTipi) => { setTicaretTipi(dispatch, ticaretTipi); }
});

export default connect(null, mapDispatchToProps)(TicaretTipiDropDown);


// WEBPACK FOOTER //
// ./src/components/containers/TicaretTipiDropDown.js